import { Car, useSteps } from '../../contexts/stepContext';
import { DetailsIcon, TableColumn, TableLine } from './styles';

interface TableItemProps {
  plate: Car;
}
const TableItem: React.FC<TableItemProps> = ({ plate }) => {
  const { listPlatesPerPage, searchPlate } = useSteps();

  async function handleGetPlacasDetails() {
    searchPlate(plate.car_plate);
  }

  return (
    <TableLine>
      <TableColumn width="25%">{plate.car_plate}</TableColumn>
      {!listPlatesPerPage ? (
        <TableColumn width="50%">
          {plate.loc_name} - {plate.loc_city} - {plate.loc_state}
        </TableColumn>
      ) : (
        <TableColumn width="50%">{plate.car_model}</TableColumn>
      )}

      <TableColumn width="25%">
        <button type="button" onClick={handleGetPlacasDetails}>
          <DetailsIcon />
        </button>
      </TableColumn>
    </TableLine>
  );
};

export default TableItem;
